import {
  authorizeDeleteRequest,
  authorizeGetRequest,
  authorizePatchRequest,
  authorizePostRequest,
} from "api";
import { IPaginatedResponse } from "models";
import { IFaq, IFaqInput, IFaqResponse } from "models/faq";

export const faqsApi = (page: number, perPage: number, search: string) => {
  return authorizeGetRequest<IPaginatedResponse<IFaq>>(
    `faqs?page=${page}&per_page=${perPage}&search=${search}`
  );
};

export const createFaqApi = (data: IFaqInput) => {
  return authorizePostRequest<IFaq>("faqs", data);
};

export const updateFaqApi = (id: string, data: IFaqInput) => {
  return authorizePatchRequest<IFaq>(`faqs/${id}`, data);
};

export const deleteFaqApi = (id: string) => {
  return authorizeDeleteRequest<IFaq>(`faqs/${id}`);
};

export const fetchFaqByIdApi = (id: string) => {
  return authorizeGetRequest<IFaqResponse>(`faqs/${id}`);
};
